<template lang="pug">
  v-container( fill-height fluid pa-0 ma-0 )
    v-row( no-gutters align="center" justify="center")
      v-col(class="tw-mx-12" )
          v-flex(class=" tw-text-center tw-w-full text-center tw-pb-8")
            v-img( src="img/logo-full.png" width="120"  position="center center" class="tw-ml-auto tw-mr-auto"  )
          v-form(ref="form" v-model="valid" lazy-validation @keyup.native.enter="valid && submit($event)")
            v-text-field(v-model="email" :rules="emailRules" label="User Name" required)
            v-text-field(v-model="password" :rules="passwordRules" type="password" label="Password" required)
    v-row( no-gutters align="center")
      v-col(class="tw-mx-12 tw-text-indigo-100")
        v-btn( rounded block elevation="0" @click="submit" color="indigo" height="40" class="text-gray-100 tw-rounded-full" ) 
          span(class=" tw-text-indigo-100") Login
    v-dialog( v-model="error" persistent no-click-animation @click:outside="closeError()" )
      v-card( color="red lighten-1" @click="closeError" :ripple="false"  )
                  v-row(align="center" justify="center")
                      v-col(cols="auto")
                          div( class="tw-font-medium white--text text--lighten-4")
                              |{{ error_message }}

      
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      valid: true,
      error: false,
      error_message: '',
      password: '',
      passwordRules: [
        v => !!v || 'Please enter your password'
      ],
      email: '',
      emailRules: [
        v => !!v || 'Please enter your user'
      ]
    }
  },
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    closeError(){
        this.error = false
    },

    submit () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('login', {
          email: this.email,
          password: this.password
        })
          .then(response => {
            this.$router.push({ name: 'Main' })
          })
          .catch(error => {
            this.error = true
            this.error_message = "Invalid user name or password"
          })
      }
    }
  }
}
</script>
